import React from "react";
import ReactDOM from 'react-dom';
import { Component, Input, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { Banner } from '@dfds-ui/react-components';
import { theme } from '@dfds-ui/theme'
import styled from "@emotion/styled";

const ErrorMessage = styled(Banner)`
  color: ${theme.colors.noRed};
  height: 50px;
  align-items: center;
  padding-left: 0;

  svg {
      margin-right: 0.5rem;
      margin-top: 0;
  }
`

const Wrapper = styled.div`
  margin-bottom: 0.5rem;
`

@Component({
  selector: 'sbw-validation-summary',
  template: "<div #react></div>"
})
export class ValidationSummaryComponent implements OnChanges {
  @ViewChild("react", { static: true }) react: ElementRef;
  @ViewChild('scrollTarget', { static: true }) scrollTarget: ElementRef;

  @Input() errorList: string[]

  ngOnInit() {
    this.render()
  }

  render() {
    ReactDOM.render(
      <>
        {this.errorList && this.errorList.length > 0 &&
          <Wrapper>
            {this.errorList.map((error: string) =>
              <ErrorMessage className="errorMessage" key={error} intent="critical">
                {error}
              </ErrorMessage>)}
          </Wrapper>}
      </>,
      this.react.nativeElement
    );
  }

  ngOnChanges(): void {
    this.render()
  }

  constructor() { }
}
